import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'

import { Switch, FormControlLabel } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import api from 'common/api'

const useStyles = makeStyles(() => ({
  checkBoxNoMargin: {
    '& input': {
      margin: 0,
    },
  },
}))

const RoleControl = ({ role, initialAssignmentState, onChange, onError, userTarget, isUserPermitted }) => {
  const [isAssigned, setIsAssigned] = useState(initialAssignmentState)

  const { Title, Id } = role

  const classes = useStyles()

  const toggleAssignment = useCallback(
    (isAssigned) => {
      const url = `/api/users/${userTarget.Id}/roles/${Id}`
      let promise
      setIsAssigned(isAssigned)
      onChange(isAssigned)
      if (isAssigned) {
        promise = api.put(url)
      } else {
        promise = api.delete(url)
      }
      promise.catch(() => {
        setIsAssigned(!isAssigned)
        onError()
      })
    },
    [onChange, Id, userTarget, onError],
  )
  return (
    <FormControlLabel
      disabled={!isUserPermitted}
      aria-label={`toggle ${Title} permissions`}
      onClick={(e) => e.stopPropagation()}
      classes={{ root: classes.checkBoxNoMargin }}
      control={
        <Switch
          onChange={(e) => {
            e.stopPropagation()
            toggleAssignment(!isAssigned)
          }}
          disableRipple={false}
          color="primary"
          checked={isAssigned}
          name={Id}
        />
      }
      label={Title}
    />
  )
}
RoleControl.propTypes = {
  role: PropTypes.object.isRequired,
  initialAssignmentState: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  userTarget: PropTypes.object.isRequired,
  isUserPermitted: PropTypes.bool.isRequired,
}

export default RoleControl
